
import FlexibleSectionMixin from '~/mixins/flexible-section';

export default {
    mixins: [
        FlexibleSectionMixin
    ],

    props: {
        title: {
            type: String,
            default: null
        },
        background: {
            type: String,
            default: 'none'
        }
    }
};
